module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.6.2/_next/static/images/friend-justice-db9ba727e508a214bba577991b985983.png";